import { IColorScheme, IThemeSettings } from '../interfaces/config.interface'

export const getDefaultColorSchemes = (): IColorScheme[] => [
  {
    id: '1', // rouse header
    name: 'Light Neutral',
    colors: {
      background: '#FFFFFF',
      text: '#4C4C4C',
      highlight: '#000000',
      border: 'rgba(0, 0, 0, 0.23)'
    }
  },
  {
    id: '2', // rouse blue background
    name: 'Accent Blue',
    colors: {
      background: '#2C4D9E',
      text: '#FFFFFF',
      highlight: '#FFFFFF',
      border: '#FFFFFF'
    }
  },
  {
    id: '3', // rouse dark background
    name: 'Dark Neutral',
    colors: {
      background: '#4C4C4C',
      text: '#FFFFFF',
      highlight: '#FFFFFF',
      border: '#FFFFFF'
    }
  },
]

export const getDefaultHeaderSchemeMapping = () => {
  return {
    main: '1',
    actions: '1',
  }
}

export const getDefaultFooterSchemeMapping = () => {
  return {
    main: '3',
    icons: '3',
    links: '3',
  }
}

export const getDefaultAssetCardSchemeMapping = () => {
  return {
    main: '1',
    price: '1',
    badges: '2',
    viewButton: '1',
    contactButton: '2',
  }
}

export const getDefaultComparisonSchemeMapping = () => {
  return {
    main: '1',
    subheader: '2',
  }
}

export const getDefaultHeroBannerSchemeMapping = () => {
  return {
    main: '3',
    pills: '1',
    cta: '2',
  }
}

export const getDefaultBrowseByMakeSchemeMapping = () => {
  return {
    main: '1',
    items: '1',
  }
}

export const getDefaultBrowseByCategorySchemeMapping = () => {
  return {
    main: '1',
    items: '1',
  }
}

export const getDefaultContactFormSchemeMapping = () => {
  return {
    main: '1',
    buttons: '2',
  }
}

export const getDefaultFiltersSchemeMapping = () => {
  return {
    main: '1',
    header: '1',
    pills: '3',
  }
}

export const getDefaultPdpActionButtonsSchemeMapping = () => {
  return {
    contactButton: '2',
    financeButton: '2',
    downloadButton: '1',
  }
}

export const getDefaultFeaturedCarouselSchemeMapping = () => {
  return {
    main: '1',
  }
}

export const getDefaultSearchPageSchemeMapping = () => {
  return {
    main: '1',
  }
}

export const getDefaultDetailsPageSchemeMapping = () => {
  return {
    main: '1',
  }
}

export const getDefaultDetailsInformationSchemeMapping = () => {
  return {
    buttons: '1',
  }
}

export const getDefaultDetailsStickyHeaderSchemeMapping = () => {
  return {
    main: '2',
  }
}

export const getDefaultShippingBannerSchemeMapping = () => {
  return {
    main: '1',
  }
}

export const getDefaultSimilarCarouselSchemeMapping = () => {
  return {
    main: '1',
  }
}

export const getDefaultRecentlyViewedCarouselSchemeMapping = () => {
  return {
    main: '1',
  }
}

export const getDefaultLegalTermsSchemeMapping = () => {
  return {
    main: '1',
  }
}

export const getDefaultQuickLinksSchemeMapping = () => {
  return {
    main: '1',
  }
}

export const getDefaultColorSchemeMapping: () => IThemeSettings = () => {
  return {
    header: getDefaultHeaderSchemeMapping(),
    footer: getDefaultFooterSchemeMapping(),
    assetCard: getDefaultAssetCardSchemeMapping(),
    comparison: getDefaultComparisonSchemeMapping(),
    heroBanner: getDefaultHeroBannerSchemeMapping(),
    featuredCarousel: getDefaultFeaturedCarouselSchemeMapping(),
    browseByMake: getDefaultBrowseByMakeSchemeMapping(),
    browseByCategory: getDefaultBrowseByCategorySchemeMapping(),
    contactForm: getDefaultContactFormSchemeMapping(),
    searchPage: getDefaultSearchPageSchemeMapping(),
    filters: getDefaultFiltersSchemeMapping(),
    detailsPage: getDefaultDetailsPageSchemeMapping(),
    detailsInformation: getDefaultDetailsInformationSchemeMapping(),
    detailsStickyHeader: getDefaultDetailsStickyHeaderSchemeMapping(),
    shippingBanner: getDefaultShippingBannerSchemeMapping(),
    similarCarousel: getDefaultSimilarCarouselSchemeMapping(),
    recentlyViewedCarousel: getDefaultRecentlyViewedCarouselSchemeMapping(),
    pdpActionButtons: getDefaultPdpActionButtonsSchemeMapping(),
    legalTerms: getDefaultLegalTermsSchemeMapping(),
    quickLinks: getDefaultQuickLinksSchemeMapping()
  }
}
